// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n, { langAvailables } from './i18n'

import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VueAnalytics from 'vue-analytics'
import VueSmoothScroll from 'vue-smoothscroll'
import VueYoutubeEmbed from 'vue-youtube-embed'

Vue.config.productionTip = false

// Force lang by query params
// router.beforeEach((to, from, next) => {
//   if (to.query.lang) {
//     i18n.locale = to.query.lang
//   }

//   next()
// })

router.beforeEach((to, from, next) => {
  if (to.params.lang) {
    const lang = to.params.lang

    if (langAvailables.indexOf(lang) === -1) {
      return next(i18n.locale)
    }
  }

  next()
})

router.afterEach((to, from) => {
  i18n.locale = to.params.lang || 'fr'
})

Vue.use(VueResource)
Vue.use(VeeValidate)
Vue.use(VueAnalytics, {
  id: 'UA-98768832-4',
  autoTracking: {
    exception: true
  },
  router
})
Vue.use(VueSmoothScroll)
Vue.use(VueYoutubeEmbed)

Vue.http.options.root = process.env.API_BASE_URL

/* eslint-disable no-new */
var root = new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  router,
  i18n
})

document.addEventListener('DOMContentLoaded', function () {
  root.$mount('#app')
})



// WEBPACK FOOTER //
// ./src/main.js